// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G0ue","label":"styles_label__DE9Z5"};